

































































import {
  CourseLicenseTemplateResponse,
  ValidateLicenseTemplateReplacersDTO,
  ValidatePlaceholderResponse
} from '@/jbi-shared/dto/jtms.dtos';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import {
  GetGroupsProductResponsePayload,
  GroupProduct
} from '@/store/modules/admin/types/group-product.types';
import { CourseLicenseTemplateReplacer } from '@/store/modules/jtms/course-license-template/course-license-template.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({})
export default class CourseLicenseTemplateForm extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object })
  courseLicenseTemplate!: CourseLicenseTemplateResponse;
  @PropSync('name', { type: String }) syncedName!: string;
  @PropSync('product', { type: Object }) syncedProduct!: GroupProduct;

  nameFieldMessage: string = '';
  productFieldMessage: string = '';

  nameHasError: boolean = true;
  productHasError: boolean = true;

  nameFieldMessageType: string = '';

  @Action('courseLicenseTemplate/validateLicenseTemplatePlaceholders')
  validateLicenseTemplatePlaceholders!: (
    payload: ValidateLicenseTemplateReplacersDTO
  ) => void;

  @State((state: RootState) => state.admin.groupProducts)
  groupProducts!: GetGroupsProductResponsePayload;

  @State((state: RootState) => state.courseLicenseTemplate.availableReplacers)
  availableReplacers!: CourseLicenseTemplateReplacer[];

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.validatePlaceholderResponse
  )
  validatePlaceholderResponse!: ValidatePlaceholderResponse;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState.validateLicenseTemplatePlaceholders
  )
  validateLicenseTemplatePlaceholdersApiState!: ApiState;

  get groupProductOptions() {
    if (this.groupProducts) {
      return this.groupProducts.items;
    }
    return [];
  }

  get availableReplacerOptions() {
    if (this.availableReplacers) {
      return this.availableReplacers
        .map((replacer) => replacer.placeholder)
        .join(', ');
    }
    return 'Could not retrieve any replacers.';
  }

  get hasInvalidTemplateName() {
    if (this.validatePlaceholderResponse) {
      return (
        !this.validatePlaceholderResponse.hasValidReplacers &&
        this.validatePlaceholderResponse.invalidPlaceholders
      );
    }

    return true;
  }

  get hasNameChanged() {
    if (this.isEdit && this.courseLicenseTemplate) {
      return this.courseLicenseTemplate.name !== this.syncedName;
    }

    return true;
  }

  get hasGroupProductChanged() {
    if (this.isEdit && this.courseLicenseTemplate) {
      return (
        this.courseLicenseTemplate.groupProductId !== this.syncedProduct.id
      );
    }

    return true;
  }

  get hasValuesChanged() {
    if (this.isEdit) {
      return this.hasNameChanged || this.hasGroupProductChanged;
    }
    return true;
  }

  @Debounce(700)
  handleTemplateNameVerification() {
    if (!this.hasNameChanged) {
      return;
    }
    this.validateLicenseTemplatePlaceholders({ nameString: this.syncedName });
  }

  clearNameFieldAttr(): void {
    this.nameHasError = false;
    this.nameFieldMessage = '';
    this.nameFieldMessageType = '';
  }

  @Watch('syncedName')
  validateNameField(): void {
    // validate null / empty values for required fields
    if (!this.syncedName) {
      this.nameFieldMessage = 'Name field cannot be empty.';
      this.nameFieldMessageType = 'is-danger';
      this.nameHasError = true;
      return;
    }
    this.clearNameFieldAttr();
  }

  @Watch('syncedProduct')
  validateAccreditationField(): void {
    // validate null / empty values for required fields
    if (!this.syncedProduct) {
      this.productFieldMessage = 'Product field cannot be empty.';
      this.productHasError = true;
      return;
    }
    this.productFieldMessage = '';
    this.productHasError = false;
  }

  @Watch('validateLicenseTemplatePlaceholdersApiState', { deep: true })
  verifyTemplateNameApiStateCallback(verifyState: ApiState): void {
    if (verifyState.success) {
      if (this.syncedName === '') {
        return;
      }

      if (this.hasInvalidTemplateName) {
        this.nameHasError = true;
        this.nameFieldMessage = this.validatePlaceholderResponse.message!;
        this.nameFieldMessageType = 'is-danger';
        return;
      }

      this.nameHasError = false;
      this.nameFieldMessage = 'Template name is available.';
      this.nameFieldMessageType = 'is-success';
    }

    if (verifyState.error) {
      this.nameHasError = true;
      this.nameFieldMessage = verifyState.error.message;
      this.nameFieldMessageType = 'is-danger';
    }
  }

  updateErrorState() {
    const hasFieldError =
      this.nameHasError ||
      this.productHasError ||
      this.validateLicenseTemplatePlaceholdersApiState.loading ||
      !this.hasValuesChanged;

    this.$emit('update-error', hasFieldError);
  }

  @Watch('hasValuesChanged', { immediate: true })
  @Watch('nameHasError', { immediate: true })
  @Watch('productHasError', { immediate: true })
  checkErrorMessageCallback(): void {
    this.updateErrorState();
  }
}
